import React from 'react'

export default function MenuDivider({ style }) {
  const styleWithDefaults = Object.assign({}, style || {}, {
    width: '2px',
    height: '26px',
    color: '#ABB3BA',
  })
  return (
    <svg viewBox="0 0 2 26" style={styleWithDefaults}>
      <line
        stroke="currentColor"
        strokeDasharray="2, 1"
        strokeWidth="1"
        x1="1"
        y1="0"
        x2="1"
        y2="26"
      />
    </svg>
  )
}
